import React from "react";
import { isCOAComplete } from "../../../utils/coaPanelStatus";
import "./MarketplaceCell.css";

export default function MarketplaceCell({ product, onPublish, onUnpublish }) {
    const isLive = !!product.published;
    const hasFullPanel = product.coa_id && isCOAComplete(product);

    function handleClick(e) {
        e.stopPropagation();
        if (isLive) {
            onUnpublish(product);
        } else if (hasFullPanel) {
            onPublish(product);
        }
    }

    if (isLive) {
        return (
            <span className="dash-tooltip-wrap" data-tip="Click to remove from marketplace">
                <span
                    className="marketplace-cell marketplace-cell--live"
                    onClick={handleClick}
                >
                    LIVE
                </span>
            </span>
        );
    }

    const tip = hasFullPanel
        ? "Click to publish to marketplace"
        : "Product needs full panel coverage to publish to marketplace";

    return (
        <span
            className="dash-tooltip-wrap"
            data-tip={tip}
            {...(!hasFullPanel ? { "data-tip-type": "warning" } : {})}
        >
            <span
                className={`marketplace-cell marketplace-cell--publish${hasFullPanel ? "" : " marketplace-cell--disabled"}`}
                onClick={handleClick}
            >
                Publish
            </span>
        </span>
    );
}
